<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer dropDown">
        <span class="cursor-pointer flex i18n-locale">
            <img class="h-4 w-5" style="margin-top: 2px;" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" />
            <!--<span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>-->
        </span>
        <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown" style="z-index: 999999;">
            <vs-dropdown-item v-if="$i18n.locale !== 'en'" @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
            <vs-dropdown-item v-if="$i18n.locale !== 'az'" @click="updateLocale('az')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/az.png" alt="az" /> &nbsp;Azərbaycan</vs-dropdown-item>
            <vs-dropdown-item v-if="$i18n.locale !== 'ru'" @click="updateLocale('ru')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/ru.png" alt="ru" /> &nbsp;Русский</vs-dropdown-item>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
  export default {
      name: "Language",
      data() {
          return {
              lang : window.lang,
          }
      },
      created() {
          this.$i18n.locale = this.lang;
      },
      computed: {
          getCurrentLocaleData() {
              const locale = this.$i18n.locale;
              if (locale == "en") return { flag: "us", lang: 'English' }
              else if (locale == "ru") return { flag: "ru", lang: 'Русский' }
              else if (locale == "az") return { flag: "az", lang: 'Azərbaycan' }
          },
      },
      methods: {
          updateLocale(locale) {
              this.$i18n.locale = locale;
              this.lang = locale;
              window.lang = locale;
              localStorage.setItem('lang', locale);

              axios.get(apiUrl+'/locale/'+locale+'?token='+token, {});
              window.bus.$emit('reload-components');
          },
      }
  }
</script>

<style lang="scss" scoped>
    .dropDown{
        font-family: Montserrat,Helvetica,Arial,sans-serif;
        position:absolute;
        right:15px;
        top: 15px;
        border:1px solid #CFD2E0;
        border-radius: 5px;
        padding: 10px;
    }

    .i18n-dropdown{
        .vs-dropdown--item{
            font-size: 13px !important;
        }
    }
</style>
